import { getTheme, setTheme } from '@ui5/webcomponents-base/dist/config/Theme.js';

export const THEME_STORAGE_KEY = 'preferredUi5Theme';

export const THEMES = [
  { key: 'sap_horizon', value: 'SAP Horizon Morning' },
  { key: 'sap_horizon_dark', value: 'SAP Horizon Evening' },
  { key: 'sap_horizon_hcb', value: 'SAP Horizon HCB' },
  { key: 'sap_horizon_hcw', value: 'SAP Horizon HCW' },
  { key: 'sap_fiori_3', value: 'SAP Quartz Light' },
  { key: 'sap_fiori_3_dark', value: 'SAP Quartz Dark' },
  { key: 'sap_fiori_3_hcb', value: 'SAP Quartz HCB' },
  { key: 'sap_fiori_3_hcw', value: 'SAP Quartz HCW' }
];

const SUPPORTED_THEME_KEYS = new Set(THEMES.map((theme) => theme.key));
const DEFAULT_THEME = THEMES[0].key;

export const isSupportedTheme = (theme) => SUPPORTED_THEME_KEYS.has(theme);

export const getStoredTheme = () => {
  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  return isSupportedTheme(storedTheme) ? storedTheme : null;
};

export const getResolvedTheme = () => {
  const activeTheme = getTheme();
  if (isSupportedTheme(activeTheme)) {
    return activeTheme;
  }

  const storedTheme = getStoredTheme();
  if (storedTheme) {
    return storedTheme;
  }

  return DEFAULT_THEME;
};

export const applyTheme = (theme) => {
  if (!isSupportedTheme(theme)) {
    return getResolvedTheme();
  }

  setTheme(theme);
  localStorage.setItem(THEME_STORAGE_KEY, theme);
  return theme;
};

export const initializeTheme = () => {
  const resolvedTheme = getStoredTheme() || getResolvedTheme();

  if (getTheme() !== resolvedTheme) {
    setTheme(resolvedTheme);
  }

  localStorage.setItem(THEME_STORAGE_KEY, resolvedTheme);
  return resolvedTheme;
};
